import { render, staticRenderFns } from "./FooterToolbar.vue?vue&type=template&id=1a5fd12e"
import script from "./FooterToolbar.vue?vue&type=script&lang=js"
export * from "./FooterToolbar.vue?vue&type=script&lang=js"
import style0 from "./FooterToolbar.vue?vue&type=style&index=0&id=1a5fd12e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports